import React from 'react';
import { Stat, StatLabel, StatNumber, StatHelpText, Flex } from '@chakra-ui/react';
import { UserCustomFieldValue } from '../../types/customFields';

// Display component props
export interface CustomFieldDisplayProps {
    field: UserCustomFieldValue;
}

/**
 * Component for displaying a single custom field value
 * Shows field name, formatted value, and appropriate icon
 */
export const CustomFieldDisplay: React.FC<CustomFieldDisplayProps> = ({ field }) => {
    // Check if field has no value
    return (
        <Flex alignItems="flex-start" gap={2}>
            <Stat flex={1}>
                <StatLabel>{field.displayName}</StatLabel>
                <StatNumber>{field.formattedValue}</StatNumber>
                <StatHelpText>{field.description}</StatHelpText>
            </Stat>
        </Flex>
    );
};

export default CustomFieldDisplay;
